/**
 * Builds removeAssetProductLinks filters from detachAssetsFromTargets UI targets.
 */
export const buildRemovedLinksFromDetachTargets = ({ masterProductId, targets = {} }) => {
  const products = [];
  const productVariants = [];

  if (targets.masterGallery) {
    products.push({ _id: masterProductId });
  }

  (targets.masterVariantIds || []).forEach((variantId) => {
    productVariants.push({
      variantId,
      productId: masterProductId,
      type: 'masterVariant',
    });
  });

  (targets.listings || []).forEach((listing) => {
    if (listing.listingGallery) {
      products.push({ _id: listing.listingId, isDraft: true });
    }

    (listing.listingVariantIds || []).forEach((variantId) => {
      productVariants.push({
        variantId,
        productId: listing.listingId,
        type: 'listingVariant',
        isDraft: true,
      });
    });
  });

  return { products, productVariants };
};

export default buildRemovedLinksFromDetachTargets;
